export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--1.800ba5d2.png";